<template>
  <div class="loader" v-if="this.isLoading">
    <img class="rounded mx-auto d-block" src="@/assets/loading.gif" />
  </div>
  <div class="w-100 header text-center" v-if="path" >
      <div class="container">
        <nav class="navbar" style="display:block !important;">
          <div class=" " style="text-aling:center;">
            <a class="navbar-brand " >
              <img class="img-fluid img-header"  src="@/assets/enjoy/header.png" >
            </a>
          </div>
        </nav>
      </div>
    </div>
    <div class="w-100 headerClub text-center" v-if="!path" >
      <div class="container">
        <nav class="navbar" style="display:block !important;">
          <div class=" " style="text-aling:center;">
            <a class="navbar-brand " >
              <img class="img-fluid img-header"  src="@/assets/clubEnjoy/header.png" style="margin-bottom:15px;" >
            </a>
          </div>
        </nav>
      </div>
    </div>
  <section>
    <div class="block-1 w-100">
      <div class="my-lg-4 mx-md-0 mx-lg-5 px-md-3" style="margin-top: 0px !important;">
        <div class="row mx-auto col-md-8 col-sm-12">
          <div class="col-lg-6 col-sm-12 mt-5">
            <div class="text-center" style="width: 90%;">
              <img class="logo w-100" v-if="path" src="@/assets/enjoy/duranteMayo.png" style="margin-top:15px; margin-bottom:20px;">
              <img class="logo w-100" v-if="!path" src="@/assets/clubEnjoy/lateral.png" style="margin-top:15px; margin-bottom:20px;">
              <img class="logo w-100" v-if="path" src="@/assets/enjoy/2Pasajes.png" style="margin-bottom:40px;">
              <img class="logo w-100" v-if="path" src="@/assets/enjoy/opciones.png" alt="" >
            </div>
          </div>

          <div class="col-lg-6 col-sm-12">
            <div class="text-center">
              <img class="w-100" v-if="path" src="@/assets/enjoy/inscribeteHoy.png" style="margin-top:60px; "/>
              <img class="w-100" v-if="!path" src="@/assets/clubEnjoy/inscribeteHoy.png" style="margin-top:60px; "/>
            </div>
            <div class="text-center">
              <img class="w-100" v-if="path" src="@/assets/enjoy/inscribeteGratis.png" style="margin-top:15px; margin-bottom:10px;"/>
              <img class="w-100" v-if="!path" src="@/assets/clubEnjoy/inscribeteGratis.png" style="margin-top:15px; margin-bottom:10px;"/>
            </div>
            
            <div class="box-content rounded" v-if="mostrarFormulario">
              <form @submit.prevent="guardarDatos()">
                <div class="form-label-group">
                  <input
                    class="form-control mt-3 inputGeneral"
                    maxlength="10"
                    type="text"
                    placeholder="Rut"
                    v-model="f1Rut"
                    disabled
                  />
                  <span  class="error"
                  v-if="v$.f1Rut.Fn.$invalid && v$.f1Rut.$dirty"
                    >*El RUT ingresado no es valido</span
                  >
                  <p class="mdi-12px op_50 ex-rut mt-2 d-block">
                    Ej: RUT: 15749387-4 
                  </p>
                </div>
                <div class="form-label-group ">
                  <input
                    class="form-control inputGeneral"
                    maxlength="50"
                    type="text"
                    id="nombref1"
                    name="nombref1"
                    placeholder="Nombre"
                    v-model="f1Nombre"
                    required
                  />
                  <span
                    class="error"
                    v-if="v$.f1Nombre.required.$invalid && v$.f1Nombre.$dirty"
                    >*El campo no puede estar vacío</span
                  >
                </div>
                <div class="form-label-group">
                  <input
                    class="form-control mt-3 inputGeneral"
                    maxlength="50"
                    type="text"
                    placeholder="Apellido"
                    v-model="f1Apellido"
                  />
                  <span
                    class="error"
                    v-if="v$.f1Apellido.required.$invalid && v$.f1Apellido.$dirty"
                    >*El campo no puede estar vacío</span
                  >
                  <!---->
                  <!---->
                </div>
                <div class="form-label-group">
                  <label class="mr-3 mt-4 mb-0"> Género (Opcional):</label>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="M"
                      v-model="f1Genero"
                    />
                    <label class="form-check-label" for="inlineRadio1"
                      >Masculino</label
                    >
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="F"
                      v-model="f1Genero"
                    />
                    <label class="form-check-label" for="inlineRadio2"
                      >Femenino</label
                    >
                  </div>
                  <span
                    class="error"
                    v-if="v$.f1Genero.required.$invalid && v$.f1Genero.$dirty"
                    ><br />*Debe seleccionar una opción</span
                  >
                </div>

                <div class="form-label-group mt-3">
                  <select
                    class="form-control"
                    formcontrolname="pais"
                    placeholder="País"
                    v-model="f1Pais"
                  >
                    <option
                      v-for="pais in listaPaises"
                      :key="pais.codigo"
                      :value="pais.codigo"
                    >
                      {{ pais.nombre }}
                    </option>
                  </select>
                </div>
                
                <div class="form-group mb-3">
                  <label class="mb-2"> Fecha de Nacimiento </label>
                  <div class="row mb-0">
                    <div class="col-4 col-md-3">
                      <select
                        class="form-control"
                        formcontrolname="dia"
                        placeholder="Día"
                        type="text"
                        v-model="f1Dia"
                      >
                        <option selected="" value="">Día</option>
                        <option value="01">01</option>
                        <option value="02">02</option>
                        <option value="03">03</option>
                        <option value="04">04</option>
                        <option value="05">05</option>
                        <option value="06">06</option>
                        <option value="07">07</option>
                        <option value="08">08</option>
                        <option value="09">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                      </select>
                    </div>
                    <div class="col-4 col-md-3">
                      <select
                        class="form-control"
                        formcontrolname="mes"
                        placeholder="Mes"
                        type="text"
                        v-model="f1Mes"
                      >
                        <option selected="" value="">Mes</option>
                        <option value="01">01</option>
                        <option value="02">02</option>
                        <option value="03">03</option>
                        <option value="04">04</option>
                        <option value="05">05</option>
                        <option value="06">06</option>
                        <option value="07">07</option>
                        <option value="08">08</option>
                        <option value="09">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                      </select>
                    </div>
                    <div class="col-4 col-md-3">
                      <select
                        class="form-control"
                        formcontrolname="anio"
                        type="text"
                        v-model="f1Agno"
                      >
                        <option selected="" value="">Año</option>
                        <option
                          v-for="agno in listaAgnos"
                          :key="agno"
                          :value="agno"
                        >
                          {{ agno }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!---->
                  <span
                    class="error"
                    v-if="v$.f1Dia.required.$invalid && v$.f1Dia.$dirty"
                    >*Debe seleccionar día de nacimiento <br
                  /></span>
                  <span
                    class="error"
                    v-if="v$.f1Mes.required.$invalid && v$.f1Mes.$dirty"
                    >*Debe seleccionar mes de nacimiento <br
                  /></span>
                  <span
                    class="error"
                    v-if="v$.f1Agno.required.$invalid && v$.f1Agno.$dirty"
                    >*Debe seleccionar año de nacimiento</span
                  >
                </div>
                <div class="form-group mb-3">
                  <select
                    class="form-control"
                    formcontrolname="casino"
                    id="inputState"
                    v-model="f1Casino"
                  >
                    <option selected="" value="">Casino Preferido</option>
                    <option
                      v-for="casino in listaCasinos"
                      :key="casino.id"
                      :value="casino.id"
                    >
                      {{ casino.nombre }}
                    </option>
                  </select>
                  <span
                    class="error"
                    v-if="v$.f1Casino.required.$invalid && v$.f1Casino.$dirty"
                    >*Debe seleccionar un casino</span
                  >
                  <!---->
                </div>
                <div class="formu-app form-label-group mb-3">
                  <input
                    class="form-control mb-0"
                    formcontrolname="txtInpuTlf"
                    maxlength="9"
                    type="tel"
                    placeholder="Teléfono: 912345678"
                    v-model="f1Telefono"
                  />
                  <span
                    class="error"
                    v-if="v$.f1Telefono.required.$invalid && v$.f1Telefono.$dirty || v$.f1Telefono.minLength.$invalid  "
                    >*Debe ingresar un número de teléfono</span
                  >
                </div>
                <div class="form-label-group mb-3">
                  <input
                    class="form-control mb-0 inputGeneral"
                    formcontrolname="txtInpuEmail"
                    maxlength="50"
                    type="email"
                    placeholder="Email"
                    v-model="f1Email"
                  />
                  <span
                    class="error"
                    v-if="v$.f1Email.required.$invalid && v$.f1Email.$dirty"
                    >*Debe ingresar un mail valido</span
                  >
                  <span
                    class="error"
                    v-if="v$.f1Email.email.$invalid && v$.f1Email.$dirty"
                    >*Debe ingresar un mail valido</span
                  >
                </div>
                <div class="mb-4 checck">
                  <div class="custom-control form-check">
                    <input
                      class="custom-control-input mb-3 form-check-input"
                      id="customCheck1"
                      type="checkbox"
                      :true-value="1"
                      :false-value="0"
                      v-model="f1AceptoCondiciones"
                    />
                    <label class="form-check-label"
                      ><a
                        class="text-white"
                        href="https://static.enjoy.cl/bibliotecamedios/BasesLegales/REGLAMENTO_PROGRAMA_ENJOY_CLUB_2022_20220110_11100020220110_111000.pdf"
                        target="_blank"
                        ><span class="mt-1"
                          >Acepto las condiciones y términos
                        </span></a
                      ></label
                    >
                  </div>
                  <span
                    class="error"
                    v-if="v$.f1AceptoCondiciones.minValue.$invalid && v$.f1AceptoCondiciones.$dirty"
                    >*Debe aceptar términos y condiciones</span
                  >
                </div>

                <div
                  class="col-lg-12 col-md-12 col-sm-12 mx-sm-auto mx-0 p-0 "
                >
                  <button
                    class="btn-inscribir negro text-uppercase fw-bold mb-3 w-100 mt-3 fs-4 ultra rounded"
                    type="submit"
                    style="font-size: 20px !important;"
                    :disabled="cargaBoton"
                    @click="guardarDatos()"
                  >
                   ENVIAR DATOS
                  </button>
                </div>
              </form>
              <span
                    class="error"
                    v-if="esMenorEdad"
                    >*Debes ser mayor de edad para poder registrarte <br
                  /></span>
              
            </div>
            <div class="box-content rounded" v-if="mostrarRut">
              <form @submit.prevent="validaPersona()">
                <p>Ingrese su RUT</p>
                <div class="form-label-group">
                  <input
                    class="form-control mt-3 inputGeneral"
                    maxlength="10"
                    type="text"
                    placeholder="Rut "
                    v-model="f1Rut"
                  />
                  <span  class="error"
                  v-if="v$.f1Rut.Fn.$invalid && v$.f1Rut.$dirty"
                    >*El RUT ingresado no es valido</span
                  >
                  <p class="mdi-12px op_50 ex-rut mt-2 d-block">
                    Ej: RUT: 15749387-4 
                  </p>
                </div>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 mx-sm-auto mx-0 p-0 "
                >
                  <button
                    class="btn-inscribir negro text-uppercase fw-bold mb-3 w-100 mt-3 fs-4 ultra rounded"
                    type="submit"
                    style="font-size: 20px !important;"
                    :disabled="cargaBoton"
                    @click="validaPersona()"
                  >
                   REGISTRARME
                  </button>
                </div>
              </form>
              <div class="rounded" v-if="mostrarRegistrado">
                <img class="w-100" v-if="path" src="@/assets/enjoy/rectangulo.png" />
                <img class="w-100" v-if="!path" src="@/assets/enjoy/rectangulo.png" />
              </div>
            </div>
            <div class="rounded" v-if="mostrarRegistradoEnrolamiento">
                <img class="w-100" v-if="path" src="@/assets/enjoy/rectangulo.png" />
                <img class="w-100" v-if="!path" src="@/assets/enjoy/rectangulo.png" />
              </div>
            <div class="rounded" v-if="mostrarExito">
                <img class="w-100" v-if="path" src="@/assets/enjoy/exitoso.png" />
                <img class="w-100" v-if="!path" src="@/assets/enjoy/exitoso.png" />
              </div>
            
            
          </div>
        </div>
      </div>
    </div>

    <div class="block-2 w-100">
      <div class="py-5 my-lg-4 mx-md-0 mx-lg-5 px-md-3 text-center">
        <div class="row mx-auto col-md-8 col-sm-12">
          <a v-if="path" :href="`${publicPath}`+`${this.var.nombreArchivoEnjoy}`" download="CONDICIONES ENROLAMENTO LATAM MAYO 2022" target="_blank" style="margin-bottom:10px;">
            <img class="logo w-100"  src="@/assets/enjoy/revisaBases.png" alt=""  >
          </a>
          <img class="logo w-100" v-if="path" src="@/assets/enjoy/bases.png" alt="" >
          <a v-if="path" href="https://static.enjoy.cl/bibliotecamedios/BasesLegales/REGLAMENTO_PROGRAMA_ENJOY_CLUB_2022_20220110_11100020220110_111000.pdf" target="_blank" style="margin-bottom:10px;">
            <img class="logo w-100"  src="@/assets/enjoy/conoceBases.png" alt=""  >
          </a>
          <a v-if="!path" :href="`${publicPath}`+`${this.var.nombreArchivoClubEnjoy}`" download="CONDICIONES ENROLAMENTO LATAM MAYO 2022" target="_blank" style="margin-bottom:10px;">
            <img class="logo w-100"  src="@/assets/clubEnjoy/revisaBases.png" alt=""  >
          </a>
          <img class="logo w-100" v-if="!path" src="@/assets/clubEnjoy/bases.png" alt="" >
          <div style="margin-top:10px;">
            <img class="img-header" v-if="path" src="@/assets/enjoy/footer.png" alt="" >
            <img class="img-header" v-if="!path" src="@/assets/clubEnjoy/footer.png" alt="" >
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import useValidate from '@vuelidate/core'
import {
  required,
  email,
  minLength,
  numeric,
  minValue,
} from "@vuelidate/validators";
import axios from "axios";
import variables from "@/static/env.json"
const Fn = {
  // Valida el rut con su cadena completa "XXXXXXXX-X"
  validaRut: function (rutCompleto) {
    rutCompleto = rutCompleto.replace("‐", "-");
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
    var tmp = rutCompleto.split("-");
    var digv = tmp[1];
    var rut = tmp[0];
    if (digv == "K") digv = "k";
    return Fn.dv(rut) == digv;
  },
  dv: function (T) {
    var M = 0,
      S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    return S ? S - 1 : "k";
  },
};
export default {
  name: "App",
  data() {
    return {
      var:variables,
      mostrarFormulario:false,
      mostrarRegistrado:false,
      mostrarRut:true,
      v$:useValidate(),
      publicPath:process.env.BASE_URL,
      isLoading: false,
      contador: 0,
      cargaBoton: false,
      esMayorEdad: false,
      listaPaises: {},
      listaCasinos: {},
      listaDias: [],
      listaMeses: [],
      listaAgnos: [],
      diaActual: "",
      mesActual: "",
      agnoActual: "",
      f1Nombre: "",
      f1Apellido: "",
      f1Genero: "",
      f1Pais: "",
      f1Rut: "",
      f1Dia: "",
      f1Mes: "",
      f1Agno: "",
      f1Casino: "",
      f1Telefono: "",
      f1Email: "",
      esMenorEdad:false,
      f1AceptoCondiciones: 0,
      mostrarExito: false,
      mostrarRegistradoEnrolamiento:false,
      path:true,
      contadorGuardado:0
    };
  },
  components: {
    //Footer,
  },
  methods: {
    
    getCasino() {
      this.contador++;
      axios
        .get(this.var.getCasino)
        .then((data) => {
          this.listaCasinos = data.data.data;
          this.contador--;
          this.quitarLoading();
        })
        .catch((error) => {
          this.contador--;
          this.quitarLoading();
        });
    },
    getPais() {
      this.contador++;
      axios
        .get(this.var.getPais)
        .then((data) => {
          this.contador--;
          this.listaPaises = data.data.data;
          this.f1Pais = this.listaPaises[0].codigo;
          this.quitarLoading();
        })
        .catch((error) => {
          this.contador--;
          this.quitarLoading();
        });
    },
    quitarLoading() {
      if (this.contador === 0) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
      }
    },
    getFechas() {
      this.diaActual = new Date();
      var dd = String(this.diaActual.getDate()).padStart(2, "0");
      var mm = String(this.diaActual.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = this.diaActual.getFullYear();
      var mayoria = yyyy - 16;
      this.diaActual = dd;
      this.mesActual = mm;
      this.agnoActual = yyyy;
      for (let a = 1; a < 101; a++) {
        this.listaAgnos.push(mayoria - a);
      }
    },
    validaPersona(){
      this.cargaBoton = true;
      this.v$.$touch()
      this.mostrarRegistrado= false;
      if (this.v$.f1Rut.$invalid) {
        this.cargaBoton = false;
      } else {
        this.isLoading = true;
        var url=''; 
  	    var dni = this.f1Rut.replace('-',"");
        if(this.var.landingMayo){
          	url=this.var.getValidaCliente+'/'+this.var.tokenMayo+'/'+dni
        }else{
          url=this.var.getValidaCliente+'/'+this.var.tokenClubEnjoy+'/'+dni
        }
        axios
          .get(url)
          .then((data) => {
            this.cargaBoton = false;
            this.isLoading = false;
            if(data.status == 200){
              this.mostrarFormulario=true;
              this.mostrarRegistrado= false;
              this.mostrarRut=false;
              this.v$.$reset();
            }
          })
          .catch((error) => {
            this.cargaBoton = false;
            this.isLoading = false;
            if(error.response.status== 404){
              this.mostrarRegistrado=true;
            }
          });
        } 
      
    },
    guardarDatos() {
      this.contadorGuardado=this.contadorGuardado+1;
      this.cargaBoton = true;
      this.esMenorEdad=false;
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.cargaBoton = false;
        this.contadorGuardado= this.contadorGuardado-1;
      } else {
        if(this.contadorGuardado==1){
          this.esMayorEdad = false;
          //validamos edad
          if (this.agnoActual - this.f1Agno < 18) {
            if (this.f1Mes > this.mesActual) {
              this.esMayorEdad = false;
            } else if (this.f1Mes === this.mesActual) {
              if (this.f1Dia > this.diaActual) {
                this.esMayorEdad = false;
              } else if (this.f1Dia <= this.diaActual) {
                this.esMayorEdad = true;
              }
            } else {
              this.esMayorEdad = true;
            }
          } else {
            this.esMayorEdad = true;
          }
          if (this.esMayorEdad) {
            var tok="";
            if(this.var.landingMayo){
            	tok=this.var.tokenMayo
            }else{
              tok=this.var.tokenClubEnjoy
            }
            var data = {
              token: tok+'',
              rut: this.f1Rut,
              nombre: this.f1Nombre,
              apellido: this.f1Apellido,
              email: this.f1Email,
              telefono:this.f1Telefono,
              pais: this.f1Pais,
              movil: this.f1Telefono,
              fecha_nacimiento: `${this.f1Agno}-${this.f1Mes}-${this.f1Dia}`,
              sexo: this.f1Genero,
              id_unidad: this.f1Casino,
              direccion: ''
            };
            this.isLoading = true;
            this.cargaBoton = false;
            axios
              .post(this.var.postEnrolaUsuario, data)
              .then((data) => {
                this.cargaBoton = false;
                this.isLoading = false;
                this.mostrarExito=true;
                this.mostrarFormulario=false;
                this.mostrarRegistradoEnrolamiento=false;
                this.contadorGuardado= this.contadorGuardado-1;
              })
              .catch((error) => {
                this.contadorGuardado= this.contadorGuardado-1;
                this.cargaBoton = false;
                this.isLoading = false;
                
                if(error.response.status== 404){
                  this.mostrarRegistradoEnrolamiento=true;
                  this.mostrarFormulario=false;
                }
              });

          } else {
            this.cargaBoton = false;
            this.esMenorEdad=true;
            this.contadorGuardado= this.contadorGuardado-1;
          }
        }else{
          this.cargaBoton = false;
          this.contadorGuardado= this.contadorGuardado-1;
        }
        
      }
    },
  },
  validations() {
    return{
      f1Nombre: {
        required
      },
      f1Apellido: {
        required,
      },
      f1Genero: {
        required,
      },
      f1Pais: {
        required,
      },
      f1Rut: {
        Fn: Fn.validaRut
      },
      f1Dia: {
        required,
      },
      f1Mes: {
        required,
      },
      f1Agno: {
        required,
      },
      f1Casino: {
        required,
      },
      f1Telefono: {
        required,
        minLength: minLength(9),
        numeric,
      },
      f1Email: {
        required,
        email,
      },
      f1AceptoCondiciones: {
        minValue: minValue(1),
      }
    }
  },
  created() {
    this.isLoading = true;
    this.contador = 0;
    this.getFechas();
    this.getCasino();
    this.getPais();
    if(this.var.landingMayo){
      this.path=true;
    }else{
      this.path=false;
    }
  },
};
</script>
<style>
section {
  background-color: black !important;
  color: white !important;
}
.box-content {
  padding: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-width: 1px;
   background-color: rgba(252, 252, 252, 0.068);
}
.error {
  color: red;
}
.negro {
  color: black !important;
}
.btn-inscribir {
  background-color: #e8d854;
  border: none;
}
.btn-inscribir-latam {
  background-color: black;
  border: 1px solid #ff6400;
  color: white;
}
.header  {
  background-color: #ff6400;
}
.headerClub  {
  background-color: #9c39c2;
}
.icono {
  width: 15%;
}
.iconoAvion {
  width: 22%;
}
.loader {
  /* Loader Div Class */
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  opacity: 0.5;
  filter: alpha(opacity=40);
}
.btn-inscribir-orange {
  background-color: #ff6400;
  border: none;
  color: white;
}
html * {
  font-family: "Gotham", sans-serif;
}
.bold,
strong {
  font-weight: 700;
}
.normal {
  font-family: "Gotham";
  font-weight: 600;
  font-style: normal;
}
.ultra {
  font-family: "Gotham Black";
  font-weight: 500;
  font-style: normal;
}
.text-white {
  color: white;
}
.link-hover-bg {
  text-decoration: none;
}
@media (max-width: 991px) {
  .desktop {
    display: none !important;
  }
  .img-header{
    width: 40%;
  }
}
@media (min-width: 992px) {
  .mobile {
    display: none !important;
  }
  .img-header{
    width: 25%;
  }
}
</style>
